import { lazy } from 'react';
import withSuspense from '../../helpers/withSuspense.jsx';
import LoadingIndicator from '../common/loading_indicator.jsx';

const CKEditor5 = withSuspense(lazy(() => import('./Editor.jsx')), LoadingIndicator)

export default CKEditor5;
